module.exports = __webpack_public_path__ + "media/packs/images/state/small/wait_cargo_readiness-2b21ff1b4ecdcd54bea77681e5d213be.svg";